import * as React from 'react'
import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import scrollToHash from '../../../misc/helpers/scrollToHash'
import background from '../../../misc/images/backgrounds/background_10.jpg'
import { IEstateResponse } from '../../../models/Estate'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import { Breadcrumbs } from '../../reusable/Breadcrumbs'
import { Estate } from '../../templates/Estate'

const EstatePage = () => {
  const i18n = useRecoilValue(translate).estate
  const breadcrumbs = [
    {
      link: routes.estate,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const location = useLocation()
  const { data } = useSWR<IEstateResponse>(URI.getEstateUri(lang))

  useEffect(() => {
    scrollToHash(!!data, location.hash, 500)
  }, [lang, data, location.hash])

  return (
    <>
      <ImageSection id={'estates'} image={background} bottom={true} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {!!data?.data && <Estate data={data.data} />}
      </PageWrapper>
    </>
  )
}

export default EstatePage
